import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, onWriteCloudWatchLog} from './Common';

import {
  FETCH_START,
  GETCLIENT_FILELIST,
  GET_AIRES,
  AIAPI_RESULT,
  FETCH_SUCCESS,
  GETCLI_FILECOUNT,
  GET_AI_QUESTIONS,
} from '../../shared/constants/ActionTypes';

//AWS cloud watch name
var streamname = 'Redux_Actions';
var filename = 'AIchat.js';

export const getClientFileList = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios.post('v1/AI/getGoogleDriveFiles', value).then((data) => {
        dispatch({type: FETCH_SUCCESS});
        if (data?.data?.body?.success) {
          dispatch({
            type: GETCLIENT_FILELIST,
            payload: data?.data?.body?.data,
          });
          dispatch({
            type: GET_AI_QUESTIONS,
            payload: data?.data?.body?.ques_data,
          });
          dispatch({
            type: GETCLI_FILECOUNT,
            payload: data?.data?.body?.data?.length
              ? data?.data?.body?.data?.length
              : 0,
          });
        }
        dispatch({
          type: AIAPI_RESULT,
          payload: 'List Success',
        });
      });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'getClientFileList',
          '0',
          err,
        ),
      );
    }
  };
};

export const getAIresponse = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/AI/getAIResponse', value, {timeout: 100000})
        .then((data) => {
          dispatch({type: FETCH_SUCCESS});
          if (data?.data?.body?.success) {
            dispatch({
              type: GET_AIRES,
              payload: data?.data?.body?.data,
            });
            dispatch({
              type: AIAPI_RESULT,
              payload: 'AI Success',
            });
          }
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'getClientFileList',
          '0',
          err,
        ),
      );
    }
  };
};
